import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  ref: "modalRef",
  class: "modal-content neon"
}
const _hoisted_2 = { class: "overlay-image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "info-section scroll-area" }
const _hoisted_5 = { class: "info-section-wrapper" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "badge-wrapper" }
const _hoisted_8 = {
  key: 0,
  class: "badge darkBadge"
}
const _hoisted_9 = {
  key: 1,
  class: "badge darkBadge"
}
const _hoisted_10 = {
  key: 2,
  class: "badge darkBadge"
}
const _hoisted_11 = {
  key: 3,
  class: "badge darkBadge"
}
const _hoisted_12 = {
  key: 0,
  class: "info-title"
}
const _hoisted_13 = {
  key: 1,
  class: "edit-title"
}
const _hoisted_14 = { class: "actions" }
const _hoisted_15 = { class: "btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_modal_header = _resolveComponent("app-modal-header")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_app_overlay_panel = _resolveComponent("app-overlay-panel")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_modal_header, { onClose: _ctx.close }, null, 8, ["onClose"]),
    _createElementVNode("div", {
      ref: "targetRef",
      class: "ellipsis-vertical",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleImageOverlayPanel && _ctx.toggleImageOverlayPanel(...args)))
    }, [
      _createVNode(_component_font_awesome_icon, {
        size: "lg",
        icon: ['fas', 'fa-ellipsis-vertical']
      })
    ], 512),
    _createElementVNode("div", {
      class: "modal-image-choose-checkbox",
      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.selected && _ctx.selected(...args)), ["stop"]))
    }, [
      (_ctx.isSelectedMode)
        ? (_openBlock(), _createBlock(_component_AppCheckbox, {
            key: 0,
            modelValue: _ctx.selectedImage,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedImage) = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.targetRef)
      ? (_openBlock(), _createBlock(_component_app_overlay_panel, {
          key: 0,
          visible: _ctx.visible,
          "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visible) = $event)),
          width: 250,
          target: _ctx.targetRef,
          position: {
        x: 'left',
        y: 'center',
      }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "overlay-image-item",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openFolderModal && _ctx.openFolderModal(...args)))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  size: "sm",
                  icon: ['fas', 'fa-folder']
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.t('addFolder')), 1)
              ]),
              _createElementVNode("div", {
                class: "overlay-image-item",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateFolder && _ctx.updateFolder(...args)))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  size: "sm",
                  icon: ['fas', 'undo']
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.t('update')), 1)
              ]),
              _createElementVNode("div", {
                class: "overlay-image-item",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.copyLink && _ctx.copyLink(...args)))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  size: "sm",
                  icon: ['fas', 'fa-link']
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.t('copyLink')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible", "target"]))
      : _createCommentVNode("", true),
    _createElementVNode("img", {
      src: _ctx.currentImage.src,
      alt: "",
      class: "modal-image"
    }, null, 8, _hoisted_3),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(["slider-dots", { many: _ctx.images.length > 5 }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (img, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: img.id,
              class: _normalizeClass(["dot", { active: i === _ctx.index }])
            }, null, 2))
          }), 128))
        ], 2),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_ctx.localImages[_ctx.index].folder)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.localImages[_ctx.index].folder.name), 1))
              : _createCommentVNode("", true),
            (_ctx.currentImage.maskType)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.t(_ctx.currentImage.maskType)), 1))
              : _createCommentVNode("", true),
            (_ctx.currentImage.coloristicType)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.t(_ctx.currentImage.coloristicType)), 1))
              : _createCommentVNode("", true),
            (_ctx.currentImage.paletteType)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.getPaletteName(_ctx.currentImage.paletteType)), 1))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isEditTitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_font_awesome_icon, {
                  size: "xs",
                  icon: ['fas', 'fa-pencil'],
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleTitle(_ctx.currentImage.title)))
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.currentImage.title ? _ctx.currentImage.title : _ctx.t('noName')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isEditTitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_app_input, {
                  modelValue: _ctx.sign,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.sign) = $event)),
                  icon: ['fas', 'fa-pencil'],
                  "is-label": false,
                  "is-focused": ""
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", {
                  class: "edit-title-save-icon",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.updateSign && _ctx.updateSign(...args)))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    size: "sm",
                    icon: ['fas', 'undo']
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_app_button, {
              severity: "error",
              icon: ['fas', 'fa-trash'],
              onClick: _ctx.deleteImage
            }, null, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "next",
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-arrow-right'] })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "prev",
          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-arrow-left'] })
        ]))
      : _createCommentVNode("", true)
  ], 512))
}